/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/navbar.css";

const Navbar = ({ activePage }) => {
  const navigate = useNavigate();

  return (
    <div className="navbar">
      <h1 className="navbar-name">mert-arinci</h1>
      <div className="navbar-links">
        <a
          onClick={() => navigate("/")}
          className={`navbar-link ${activePage === "home" ? "active" : ""}`}
        >
          <span>_hello</span>
        </a>
        <a
          onClick={() => navigate("/about")}
          className={`navbar-link ${activePage === "about" ? "active" : ""}`}
        >
          <span>_about-me</span>
        </a>
        <a
          onClick={() => navigate("/projects")}
          className={`navbar-link ${activePage === "projects" ? "active" : ""}`}
        >
          <span>_projects</span>
        </a>
        <a
          onClick={() => navigate("/ai-chat")}
          className={`navbar-link ${activePage === "ai-chat" ? "active" : ""}`}
        >
          <span>_ai-chat</span>
        </a>
        <a
          onClick={() => navigate("/terminal")}
          className={`navbar-link link-last ${
            activePage === "terminal" ? "active" : ""
          }`}
        >
          <span>_terminal</span>
        </a>
      </div>
      <div className="navbar-pull-right">
        <a onClick={() => navigate("/contact")} className="contact-link">
          <span>_contact-me</span>
        </a>
      </div>
    </div>
  );
};

export default Navbar;
